<template>
  <div id="app">
    <router-view v-if="ready" />
    <!-- <DesktopBlocker v-if="!isMobile" /> -->

    <ErrorToast v-if="error" />
  </div>
</template>

<style>


#app {
  font-family: "Chadwick", "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.color-white {
  color: #ededed;
}
.color-red {
  color: #e2223b;
}
.color-black {
  color: #1d1d1b;
}
.color-green {
  color: #129b81;
}
.color-grey {
  color: #a4a3a1;
}

@font-face {
  font-family: Chadwick;
  src: url("/Chadwick.otf");
}

@font-face {
  font-family: ChadwickBold;
  src: url("/ChadwickBold.otf");
}
</style>

<script>
import Polyglote from "@/services/polyglote";
import DesktopBlocker from "@/components/DesktopBlocker.vue";

import ErrorToast from "@/components/ErrorToast.vue";

import moment from 'moment'

export default {
  data() {
    return {
      ready: true,
    };
  },
  methods: {
    loadLocale() {
      if (Polyglote.isLocaleSaved()) {
        this.$i18n.locale = Polyglote.getSavedLocale();
      } else {
        const loc = Polyglote.detect();

        this.$i18n.locale = loc;

        Polyglote.updateLocale(loc);
      }

      moment.locale(this.$i18n.locale);

      window.document.title = this.$t("document_title");
    },
  },
  computed: {
    // isMobile() {
    //   return window.screen.width < 576;
    // },
    error() {
      return this.$store.state.error || this.$store.state.preorder.error;
    },
  },
  components: {
    // DesktopBlocker,
    ErrorToast,
  },
  mounted() {
    this.loadLocale();
  },
};
</script>
